<template>
  <div class="row" style="height: 100%">
    <div class="col-xl-9 col-12">
      <grid ref="grid" :config="gridConfig" class="no-grid-border">
        <template v-slot:column-control-left="{ row }">
          <li v-if="row.invoiceTypeTitle">
            <logo-button :get-pdf-content="() => getPdfContent(row)" @click="(key) => onDownload(key, row)">
              {{L10n('download')}}
            </logo-button>
          </li>
        </template>
      </grid>
      <editor :includeToInvoiceList.sync="includeToInvoiceList" :config="{id: gridConfig.id, api: 'Invoices/Get/'}" :defaultData="defaultData" @on-open="handleOpenDialog"/>
    </div>
    <div class="col-xl-3 col-12 vb-xl">
      <latest-invoices />
      <template v-if="companyRemarks.length">
        <info-section-table :fields="fieldsRemarks" :data="companyRemarks" class="info-remarks">
          <template v-slot:header>
            {{L10n('company-remarks')}}
          </template>
          <template v-slot:cell-remark="{ row }">
            {{row.remark}}
          </template>
        </info-section-table>
      </template>
      <user-actions
        @onCreateInvoice="handleCreateInvoice"
        @onShowCustomerReminder="onShowCustomerReminder"
      />
      <dialog-reminder-table ref="dialog-reminder" :title="L10n('reminder-table')" :companyID="customerCompanyID" />
    </div>
  </div>
</template>

<script>
import gridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'
import { ServiceCompanyRemarks } from '@/services/CompanyRemarks'
import { ServicePdf } from '@/services/pdf-generators'
import { downloadBase64 } from '@/utils/files'

const ModelIncludeToInvoice = () => {
  return {
    includeToInvoice: false,
    id: null, // RFQ3id
    partNumber: '',
    qty: 1,
    price: '',
    partSN: '',
    conditionID: null,
    currencyID: null
  }
}

export default {
  name: 'Index',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton'),
    'editor': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './Editor'),
    'user-actions': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './UserActions'),
    'latest-invoices': () => import(/* webpackChunkName: 'Shared_LatestInvoices' */ '@/components/Shared/LatestInvoices'),
    'info-section-table': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Table.vue'),
    'dialog-reminder-table': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './DialogRemainderTable')
  },
  props: {
    moduleName: { required: true },
    rfqid: { required: true },
    po: { required: true },
    customerCompanyID: { required: true }
  },
  watch: {
    rfqid: 'loadData',
    listRFQ3: {
      immediate: true,
      handler () {
        this.includeToInvoiceList = this.listRFQ3.map((item) => {
          return this.copyObjectProps(new ModelIncludeToInvoice(), item, { includeToInvoice: item.chosen })
        })
      }
    },
    customerCompanyID: {
      immediate: true,
      handler (companyID) {
        if (companyID) {
          ServiceCompanyRemarks
            .getByCompanyID({ companyID, id: 6 })
            .then(({ data: { value } }) => {
              this.companyRemarks = value
            })
        }
      }
    }
  },
  created () {
    this.$bus.$on('on-click-tab-invoice', this.loadData)
  },
  beforeDestroy () {
    this.$bus.$off('on-click-tab-invoice', this.loadData)
  },
  data () {
    return {
      gridConfig: gridConfig,
      includeToInvoiceList: [],
      companyRemarks: []
    }
  },
  computed: {
    fieldsRemarks () {
      return [{ fieldName: 'remark' }]
    },
    defaultData () {
      return {
        po: this.po,
        rfqid: this.rfqid
      }
    },
    listRFQ3 () {
      return this.$store.state[this.moduleName].listRFQ3
    }
  },
  methods: {
    onShowCustomerReminder () {
      const dialog = this.$refs['dialog-reminder']
      if (!dialog) return

      dialog.show()
    },
    handleOpenDialog () {
      this.includeToInvoiceList = this.listRFQ3.map((item) => {
        return this.copyObjectProps(new ModelIncludeToInvoice(), item, { includeToInvoice: item.chosen })
      })
    },
    loadData () {
      this.getGrid()
        .then((grid) => {
          if (!this.rfqid) {
            return grid.resetData()
          }
          grid.setFilters(`rfqid=="${this.rfqid}" `)
          grid.loadData()
        })
    },
    handleCreateInvoice () {
      this.getGrid()
        .then((grid) => {
          grid.handleCommand('addNew')
        })
    },
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    async onDownload (logoKey, row) {
      const grid = await this.getGrid()
      try {
        grid.setLoading(true)
        const { invoiceNumber, invoiceTypeID, id } = row

        const { data: pdfBase64 } = await ServicePdf.generateInvoice({ id, invoiceTypeID, translate: this.L10n, logoKey })
        await downloadBase64(pdfBase64, `${invoiceNumber}.pdf`)
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        grid.setLoading(false)
      }
    },
    async getPdfContent (row) {
      const { invoiceTypeID, id } = row
      return ServicePdf.generateInvoiceContent({ id, invoiceTypeID, translate: this.L10n })
    }
  }
}
</script>
<style lang="stylus">
  .info-remarks{
    .info-section-table__td{
      text-align left;
      border-bottom 1px solid grey;
    }
  }
</style>
